import { Component } from '@angular/core';
import Company from '../../../model/company/company';
import { ClientCompanySelectService } from '../../../services/client-company-select.service';

@Component({
  selector: 'client-corner-home-page',
  templateUrl: './client-corner-home-page.component.html',
  styleUrls: ['./client-corner-home-page.component.scss']
})
export class ClientCornerHomePageComponent {
  selectedCompanyId: number;
  disableCreate: boolean = false;

  constructor(private clientCompanySelectService: ClientCompanySelectService) {}

  selectedCompanyChanged(company: Company): void {
    this.clientCompanySelectService.selectCompany(company);
    this.selectedCompanyId = company.id;
    this.disableCreate = company.pendingInvoices;
  }
}
